<ion-header>
  <ion-toolbar mode="md">
    <ion-title>
      Zpětná vazba ({{ assistance.client?.user?.firstName }} {{ assistance.client?.user?.lastName }})
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-info-bar level="info">
    Po uložení zpětné vazby bude odeslána zpráva koordinátorovi klienta asistence.
  </app-info-bar>
  <app-info-bar *ngIf="!assistance.realizedFrom" level="warn">
    Asistence ještě neproběhla nebo nemá vyplněný skutečný čas.
  </app-info-bar>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-textarea
          #feedbackInput
          [(ngModel)]="feedback"
          [autofocus]="true"
          [minlength]="2"
          placeholder="Vaše zpětná vazba k asistenci..."
          enterkeyhint="done"
          inputmode="text"
          auto-grow="true"
        ></ion-textarea>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<app-extended-fab (click)="save()" text="Uložit" ioniconName="checkmark"></app-extended-fab>
